import { useApi, useToaster } from "@shopexperts/shared";
import { useQuery } from "@tanstack/vue-query";
import { computed, toValue, type Ref } from "vue";

interface UseExpertBadgeSearchOptions {
  search?: Ref<string> | string;
}

export function useExpertBadgeSearch(options: UseExpertBadgeSearchOptions = {}) {
  const api = useApi();
  const toaster = useToaster();
  const { search = "" } = options;

  const searchValue = computed(() => toValue(search));

  const query = useQuery({
    queryKey: computed(() => ["expert", "badges", "search", { search: searchValue.value }]),
    queryFn: async () => {
      return await api.expert.badges.searchBadges({
        query: {
          search: searchValue.value || undefined,
        },
      });
    },
    staleTime: 5 * 60 * 1000,
  });

  if (query.error.value) {
    toaster.create({
      title: "Failed to load app and theme skills",
      type: "error",
    });
  }

  return {
    badges: computed(() => query.data.value || []),
    isLoading: query.isLoading,
    error: query.error,
  };
}

export default useExpertBadgeSearch;
